/* Components */
import DotsLoader from 'Components/DotsLoader';

/* Styles */
import './style.scss';

const Button = ({
	text,
	isSubmit,
	isLoading,
	disabled,
	className,
	action
}) => (
	<div className="button-component">
		{
			isSubmit
				? (
					<button type="submit" className={className} disabled={disabled} onClick={disabled || isLoading ? null : action}>
						{isLoading ? <DotsLoader /> : <span className="buttonPrimary">{text}</span>}
					</button>
				)
				: (
					<button type="button" className={className} disabled={disabled} onClick={disabled || isLoading ? null : action}>
						{isLoading ? <DotsLoader /> : <span className="buttonPrimary">{text}</span>}
					</button>
				)
		}
	</div>
);

Button.propTypes = {
	text: PropTypes.string.isRequired,
	isSubmit: PropTypes.bool,
	isLoading: PropTypes.bool,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	action: PropTypes.func
};

Button.defaultProps = {
	className: '',
	isSubmit: false,
	disabled: false,
	isLoading: false,
	action: null
};

export default Button;
